
const { document } = require('window');

const { EventEmitter } = require('events');

import CounterWeakMap from 'counter-weak-map';

const _ = require('lodash');
import ko from 'rgs-knockout';
const Q = require('q');

const { duration } = require('moment');

const Modernizr = require('rgs-modernizr');

const Notification = require('./notification.js');
const PassiveNotification = require('./passive-notification.js');

const $ = require('rgs-jquery');
require('rgs-velocity-animate');
const notificationBodyTemplate = require('../templates/notification-body.html');


class Notifications extends EventEmitter {
	constructor () {
		super();

		this._AllNotifications = ko.observableArray();

		this.VisibleNotifications = ko.pureComputed(() => {
			return [ _.last(this._AllNotifications()) ].filter(_.identity);
		});

		this._clickCounters = new CounterWeakMap();

		this._template = {
			nodes: $.parseHTML(notificationBodyTemplate()),
			foreach: this.VisibleNotifications,
			afterAdd: this._afterAdd.bind(this),
			beforeRemove: this._beforeRemove.bind(this),
		};

		this._AllNotifications.subscribe((changes) => {
			this._stackChange(changes);
		}, this, 'arrayChange');

		$(document).click(() => {
			const visibleNotifications = this.VisibleNotifications();

			_.each(visibleNotifications, (notification) => {
				if (this._clickCounters.has(notification)) {
					const counter = this._clickCounters.increment(notification);
					if (counter === notification.autoExpire.clickCount) {
						this._clickCounters.delete(notification);
						this.remove(notification);
					}
				}
			});
		});

		(() => {
			let oldValue = [];
			this.VisibleNotifications.subscribe((oldValue_) => {
				oldValue = oldValue_;
			}, null, 'beforeChange');
			this.VisibleNotifications.subscribe((newValue) => {
				const changes = ko.utils.compareArrays(oldValue, newValue);
				this._visibleChange(changes);
			}, null, 'change');
		})();

		this.on('shown', (notification) => {
			notification.emit('shown');
		});

		this.on('hidden', (notification) => {
			notification.emit('hidden');
		});

		this.on('added', (notification) => {
			notification.emit('added');
		});

		this.on('deleted', (notification) => {
			notification.emit('deleted');
		});
	}

	_stackChange (changes) {
		_(changes)
			.filter({ status: 'added' })
			.each(({ value: notification }) => {
				this.emit('added', notification);
			});
		_(changes)
			.filter({ status: 'deleted' })
			.each(({ value: notification }) => {
				this.emit('deleted', notification);
			});
	}

	_visibleChange (changes) {
		_(changes)
			.filter({ status: 'added' })
			.each(({ value: notification }) => {
				this.emit('shown', notification);
			});
		_(changes)
			.filter({ status: 'deleted' })
			.each(({ value: notification }) => {
				this.emit('hidden', notification);
			});
	}

	_pushNotificationInstance (notification) {
		this._AllNotifications.removeAll();
		this._AllNotifications.push(notification);

		if (typeof notification.expire === 'number') {
			Q.delay(notification.expire)
				.then(() => {
					this.remove(notification);
				})
				.done();
		}

		if (notification.autoExpire.enable) {
			this._clickCounters.add(notification);
		}

		return notification;
	}

	_pushOptions (options) {
		return this._pushNotificationInstance(this.create(options));
	}

	create (options) {
		if (_.isString(options)) {
			options = {
				message: options,
			};
		}

		options = _.defaults(options || {}, {
			type: 'passive',
			message: '',
		});

		if (this.DEFAULTS.expireAliases[options.expire]) {
			options.expire = this.DEFAULTS.expireAliases[options.expire];
		}

		const Constructor = {
			'passive': PassiveNotification,
		}[options.type];

		delete options.type;

		return new Constructor(options);
	}

	push (notification) {
		if (notification instanceof Notification) {
			return this._pushNotificationInstance(notification);
		}
		return this._pushOptions(notification);
	}

	remove (notification) {
		this._AllNotifications.remove(notification);
	}

	removeAll (filter) {
		filter = filter || _.constant(true);
		if (typeof filter === 'object') {
			const match = filter;
			filter = (notification) => {
				if (match.tags) {
					if (_.intersection(notification.tags, match.tags).length < match.tags.length) {
						return false;
					}
				}
				return true;
			};
		}
		const allNotifications = this._AllNotifications();
		_.remove(allNotifications, _.bind(filter, this));
		this._AllNotifications.valueHasMutated();
	}

	_afterAdd (node) {
		$(node)
			.parent()
				.append(node)
				.end()
			.addClass('animated shake');
	}

	_beforeRemove (node) {
		$(node).removeClass('shake').addClass('fadeOutUp');
		((Modernizr.csstransitions) ? Q.delay(duration(2, 'seconds').asMilliseconds()) : Q())
			.done(() => {
				$(node).remove();
			});
	}
}

Object.assign(Notifications.prototype, {
	DEFAULTS: {
		expireAliases: {
			'error': null,
			'success': duration(10, 'seconds').asMilliseconds(),
		},
	},
});

module.exports = Notifications;

